import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export default function controlMetricsReducer(state = initialstate.controlMetrics, action) {
	switch (action.type) {
		case types.GET_CONTROL_METRICS: {
			if (isApiResponseOk(action)) {
				// Using this helper to merge metrics based on include parameters, in order to support
				// several controlMetrics calls in the same section with different include params
				return mergeMetricsResponse(state, action.response, action);
			}
			return state;
		}

		default:
			return state;
	}
}

/**
 * Configuration object mapping include parameters to their corresponding response properties.
 * Keys stay PascalCase to match the ControlsMetrics API response contract.
 */
const METRICS_CONFIG = {
	includeControlMetric: ['CountControl', 'CountControlWithHigherRisk', 'CountControlWithIneffectiveDesign'],
	includeRelateDeficiencyMetric: ['CountControlWithDeficiency']
};

/**
 * Merges API response metrics into the state based on include parameters
 * @param {Object} state - Current state
 * @param {Object} response - API response containing metrics
 * @param {Object} includeParams - Object with flags indicating which metrics to include
 * @returns {Object} Updated state with merged metrics
 */
function mergeMetricsResponse(state, response, includeParams) {
	if (!includeParams || !response) {
		return state;
	}

	const newState = {};

	for (const [paramKey, properties] of Object.entries(METRICS_CONFIG)) {
		if (includeParams[paramKey]) {
			for (const prop of properties) {
				if (Object.prototype.hasOwnProperty.call(response, prop)) {
					newState[prop] = response[prop];
				}
			}
		}
	}

	return {
		...state,
		...newState
	};
}
